module.exports = __webpack_public_path__ + "img/logo_circular.dfe2de69.png";